<template>
<el-form :model="formFac" ref="formFac" :label-position="'top'">
    <label class="form-label">Selecciona el tipo de comprobante que deseas recibir</label>
    <el-form-item class="mb-4" prop="fndoc" :rules="[
                  {required: true, message: 'Este campo es obligatorio', trigger: 'change'}
                ]">
        <el-input :placeholder="placeHolder.voucher" v-model="formFac.fndoc" class="input-with-select" size="medium" :clearable="true" :maxlength="maxlength">
            <el-select v-model="formFac.voucher" slot="prepend" placeholder="Seleccione" @change="changeTpodocument">
                <el-option key="03" label="Boleta" value="03"></el-option>
                <el-option key="01" label="Factura" value="01"></el-option>
            </el-select>
        </el-input>
    </el-form-item>

  <label class="form-label">{{placeHolder.namebussines}}</label>
    <el-form-item prop="fname" size="medium"
        :rules="[
          {required: true, message: 'Este campo es obligatorio', trigger: ['change', 'blur']}
        ]">
        <el-input v-model="formFac.fname" :placeholder="placeHolder.namebussines"></el-input>
    </el-form-item>

    <label class="form-label">Celular</label>
    <el-form-item prop="fphone"
        :rules="[
          {required: true, message: 'Este campo es obligatorio', trigger: ['change', 'blur']}
        ]">
        <el-input v-model.number="formFac.fphone" placeholder="N° de celular" maxlength="9" size="medium"></el-input>
    </el-form-item>

    <label class="form-label">Email</label>
    <el-form-item prop="femail"
        :rules="[
          {required: true, message: 'Este campo es obligatorio', trigger: ['change', 'blur']},
          {type: 'email', message: 'Ingrese una dirección de correo electrónico correcta', trigger: ['blur', 'change']}
        ]">
        <el-input v-model="formFac.femail" placeholder="Correo electrónico" size="medium"></el-input>
    </el-form-item>
    <hr>
    <el-form-item prop="terms" :rules="[
       {required: true, message: 'Este campo es obligatorio', trigger: 'change'}
    ]">
    <el-checkbox v-model="formFac.terms">
        He leído y acepto los
        <a href="https://www.serpar.gob.pe/wp-content/uploads/2021/01/terminos.pdf" target="_blank"><b>Términos y Condiciones</b></a></el-checkbox>
    </el-form-item>

    <div class="text-right">
        <button type="button" class="btn btn-light" @click="volver">Cancelar</button>
        <button type="button" class="btn btn-danger" style="background-color:#E72176" @click="submitForm('formFac')">Ir a pagar</button>
    </div>

</el-form>
</template>

<script>
export default {

    data: () => ({
        formFac: {
            fndoc: '',
            fname: '',
            fphone: '',
            femail: '',
            voucher: '03',
            terms: null
        },
        maxlength: 8,
        placeHolder: {
            voucher: 'DNI',
            namebussines: 'Nombres'
        }

    }),
    methods: {
        changeTpodocument() {
            this.formFac.fndoc = '';
            this.maxlength = (this.formFac.voucher == '03') ? 8 : 11;
            this.placeHolder.voucher = (this.formFac.voucher == '03') ? 'DNI' : 'RUC';
            this.placeHolder.namebussines = (this.formFac.voucher == '03') ? 'Nombres' : 'Razon social';
        },
        volver() {
            this.$emit("resVolver", false)
        },

        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid)
                    return false

                this.$emit("resFact", this.formFac)
            })
        }
    },
    created() {
        this.formFac.fndoc = this.abonado.ndocument
        this.formFac.fname = this.abonado.firstname
        this.formFac.fphone = this.abonado.phone1
        this.formFac.femail = this.abonado.email
    }

}
</script>



// WEBPACK FOOTER //
// src/components/common/BolFactura.vue